import { useEffect } from "react";
import { Location, useLocation } from "react-router";

interface RouteWatcherProps {
  handlePathChange?: (location: Location) => void;
}
const RouteWatcher = ({ handlePathChange }: RouteWatcherProps) => {
  const location = useLocation();

  useEffect(() => {
    if (handlePathChange) {
      handlePathChange(location);
    }
  }, [handlePathChange, location]);
  return <span></span>;
};

export default RouteWatcher;
